module.exports = __webpack_public_path__ + "static/OpenGov-Icon-White-1ed3f3e30bba903221cd7bfdfd84c62c.png";